import {delegateEvent} from "../utils/event.delegator";
import NavBarView from 'js/views/navbar.view';
import ProfileView from 'js/views/profile.user.view';
import ManagePermissionsView from 'js/views/profile.permissions.view';
import InvoiceView from 'js/views/profile.invoice.view';
import ImportContactHistoryView from 'js/views/profile.import.contact.history.view';
import RedeemersView from 'js/views/redeemers.view';
import CustomFieldsView from 'js/views/custom.fields.view';
import CompanyDetailsView from 'js/views/company.details.view.js';
import {Backbone} from "backboneAdapter";


export default Backbone.Router.extend({
    routes: {
        "": "defaultRoute",
        "edit-profile": "editProfileTab",
        "manage-permissions": "managePermissionsTab",
        "manage-redeemers": "manageRedeemersTab",
        "import-contact-history": "importContactHistoryTab",
        "custom-fields": "customFieldsTab"
    },
    initialize: function (options) {
        const {isPostPaid} = options;
        this.navBarView = new NavBarView();
        this.profileView = new ProfileView(options);
        this.companyDetailsView = new CompanyDetailsView();
        if (!isPostPaid) {
            this.invoiceView = new InvoiceView();
        }
        this.managePermissionsView = new ManagePermissionsView(options);
        this.importContactHistoryView = new ImportContactHistoryView();
        this.redeemersView = new RedeemersView(options);
        this.customFieldsView = new CustomFieldsView();
        delegateEvent(this.profileView, this.navbar, "changed:user");
    },
    defaultRoute: function () {
        this.showTab("#edit-profile-tab");
    },
    editProfileTab: function () {
        this.showTab("#edit-profile-tab");
    },
    managePermissionsTab: function () {
        this.showTab("#manage-permissions-tab");
    },
    importContactHistoryTab: function () {
        this.showTab("#import-contact-history-tab");
    },
    manageRedeemersTab: function () {
        this.showTab("#manage-redeemers-tab");
    },
    customFieldsTab: function () {
        this.showTab("#custom-fields-tab");
    },
    showTab: function (selector) {
        const $tabs = $(".tabs");
        $tabs.find(".active").removeClass("active");
        const tab = $tabs.find(selector);
        tab.addClass("active");
        const frame = tab.find('a').attr('href');
        const $frames = $(".frames");
        $frames.children().not(frame).hide();
        $frames.find(frame).show();
    }
});
